import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { IAddWalletParams, IPaymentWalletResponse } from "@/api_framework/api_modals/payment";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: any };
export interface IOnlineToOffline{
  reason:string;
  clinic_id:string
}
export const usePaymentOnlineToOfflineGetListAPI = () => {
  
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletDetailsInProgress
  const execute = useCallback(
    async () => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.ONLINE_TO_OFFLINE_API?.baseURL}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentWalletResponse>) => {
            if (res.data.status === true) {
              // toastNotification(res.data.message);
              return { status: true, message: res.data?.data };
            } else {
              return { status: false, message: [] };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: [] };
          });
        return response;
      } catch (e: any) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
